const colors = [
    {
        color: "#E0E0E0"
    },
    {
        color: "#E0E0E0"
    },
    {
        color: "#E0E0E0"
    },
    {
        color: "#E0E0E0"
    },
    {
        color: "#FC7059"
    },
    {
        color: "#FC7059"
    },
    {
        color: "#FC7059"
    },
    {
        color: "#FC7059"
    },
    {
        color: "#F8A774"
    },
    {
        color: "#F8A774"
    },
    {
        color: "#F8A774"
    },
    {
        color: "#F8A774"
    },
    {
        color: "#E82346"
    },
    {
        color: "#E82346"
    },
    {
        color: "#E82346"
    },
    {
        color: "#E82346"
    },
]

export {
    colors
}